import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Presenter from '../../../presenter.js'
import RequestProperties from '../../request.props.js';
import FormHelper from '../../form.js';
import MessageProperties from '../../../../../config/message.js';

// TOAST
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

export default class ModalAddNote extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        title       : "",
        description : ""
    }
  }

  handleRegisterNote() {
    if (this.isPosting){
        return;
    }
    if(!FormHelper.ValidateFormNote(this.state, MessageProperties)) {
        return;
    }
    this.isPosting = true;
    Presenter.RegisterNote(
        RequestProperties.RegisterNoteProps(this, this.onRegisterSuccess, this.onRegisterFailed)
    )
  }

  clear() {
    this.setState({
        title: '',
        description: ''
    })
  }

  onRegisterSuccess(params, response) {
    params.self.props.closeModalAddNote();
    params.self.clear();
    params.self.props.updateNote(response.data)
    params.self.isPosting = false;
    toast.success("New note has been successfully added")
  }

  onRegisterFailed(response) {
    toast.error(response)
  }

  render() {
    const {isOpen, SelectedAsset} = this.props

    return (
      <Modal isOpen={isOpen} toggle={this.props.closeModalAddNote}>
        <ModalHeader toggle={this.props.closeModalAddNote}>
          <span>Add Note</span>&nbsp;<small>to asset</small>&nbsp;<span>{SelectedAsset.Name}</span>
        </ModalHeader>
        <ModalBody>
          <div className="form-group row">
            <label className="col-md-3 col-form-label">Title Note</label>
            <div className="col-md-9">
              <input type="text" 
              onChange={(e)=>this.setState({title: e.target.value })} 
              value={this.state.title} 
              className="form-control"/>
            </div>
          </div>
          <div className="form-group row">
            <label className="col-md-3 col-form-label">Note</label>
            <div className="col-md-9">
              <textarea 
                cols="30" 
                rows="3" 
                onChange={(e)=>this.setState({description: e.target.value })} 
                value={this.state.description}
                className="form-control">
              </textarea>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
            <button type="button" onClick={()=>this.handleRegisterNote()} className="btn btn-primary">Add Note</button>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/Modal/ModalAddNote.js